import type React from 'react';

import { Box } from '@mui/material';
import { Handle, Position } from '@xyflow/react';
import { useTranslate } from 'react-admin';

import IconWrapper from '../../components/IconWrapper';
import NodeIcon from '../../components/NodeIcon';
import NodeBody from '../NodeBody';
import NodeWrapper from '../NodeWrapper';

// 2px node border + 12px body padding + half a 32px icon row, then one row pitch (32px icon + 8px gap) per step. Keep in sync with IconWrapper sizing.
const firstHandleTop = 30;
const handlePitch = 40;

export default function ResponseRouterNode(): React.ReactElement {
  const translate = useTranslate();

  return (
    <NodeWrapper condensed>
      <NodeBody type='response_router' condensed>
        <Handle type='target' position={Position.Left} id='response_router-target' />
        <Box data-testid='busy_connection-source-handle'>
          <IconWrapper>
            <NodeIcon name='busy' title={translate('callflows.nodes.response_router.busyConnection')} />
          </IconWrapper>
          <Handle
            type='source'
            position={Position.Right}
            id={`busy_connection`}
            style={{ top: firstHandleTop + handlePitch * 0 }}
          />
        </Box>
        <Box data-testid='timeout_connection-source-handle'>
          <IconWrapper>
            <NodeIcon name='away' title={translate('callflows.nodes.response_router.timeoutConnection')} />
          </IconWrapper>
          <Handle
            type='source'
            position={Position.Right}
            id={`timeout_connection`}
            style={{ top: firstHandleTop + handlePitch * 1 }}
          />
        </Box>
        <Box data-testid='unreachable_connection-source-handle'>
          <IconWrapper>
            <NodeIcon name='unreachable' title={translate('callflows.nodes.response_router.unreachableConnection')} />
          </IconWrapper>
          <Handle
            type='source'
            position={Position.Right}
            id={`unreachable_connection`}
            style={{ top: firstHandleTop + handlePitch * 2 }}
          />
        </Box>
      </NodeBody>
    </NodeWrapper>
  );
}
